<template>
  <u-avatar
    :size="size"
    :src="safeUser.avatarImage"
    :alt="safeUser.name"
    :ui="uiConfig"
    img-class="object-cover"
  />
</template>

<script setup>
  const props = defineProps({
    user: Object,
    ui: Object,
    size: {
      type: String,
      default: 'md'
    }
  });

  const safeUser = computed(() => props.user || {});

  const uiConfigBase = {
    background: `${safeUser.value.profileClassName || 'bg-charcoal-500'} dark:${safeUser.value.profileClassName || 'bg-charcoal-500'}`,
    placeholder: 'text-white dark:text-white'
  };

  const uiConfig = Object.assign(uiConfigBase, props.ui);
</script>
